import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Divider, Table, Input, Row, Col, message, Spin, Tooltip, Tag } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import ErrorWrapper from '../../../lib/error_wrapper';
const queryString = require('query-string');

const data_type_schema = [
    {
        index: "name",
        name: "Name",
        type: 'text',
        // help_text:"Hello i am help text"
    }, {
        index: 'description',
        name: "Description",
        type: 'textarea'
    },
    {
        index: "debit_balance",
        name: "Add Debit Balance",
        type: 'bool',
        help_text: "Debit amount should be added or substracted? True to Add."
    },
    {
        index: 'transfer_expression',
        name: "Transfer Expression",
        type: 'text',
        help_text: "Help Content"
    }

]
const data_type_cols = ({ onEditPressed }) => [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        className: 'word-break'
    }, {
        title: "Description",
        dataIndex: "description",
        key: 'description'
    }, {
        title: "Debit Balance",
        dataIndex: 'debit_balance',
        key: 'debit_balance',
        width: 80,
        render: (debit_balance) => debit_balance ? "Add" : "Subtract"
    },
    {
        title: "Transfer Expression",
        dataIndex: 'transfer_expression',
        key: 'transfer_expression'
    },
    {
        title: "Actions",
        dataIndex: 'id',
        key: 'action',
        width: 410,
        render: (id, data) => {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'wrap'
            }}>
                <Button
                    type='link'
                    style={{ padding: 0 }}
                    onClick={() => {
                        typeof onEditPressed === 'function' && onEditPressed(id, data);
                    }}>Edit</Button>
                <Divider type='vertical' />
                <Link to={`/settings/datatype/${id}/services`}>
                    <Button style={{ padding: 0 }} type='link'>Services</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/datatype/${id}/pipelines`}>
                    <Button style={{ padding: 0 }} type='link'>Pipelines</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/datatype/${id}/balances`}>
                    <Button style={{ padding: 0 }} type='link'>Balances</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/datatype/${id}/labels`}>
                    <Button style={{ padding: 0 }} type='link'>Labels</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/datatype/${id}/actions`}>
                    <Button style={{ padding: 0 }} type='link'>Actions</Button>
                </Link>
            </div>
        }
    }
];

class DataTypeList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filter_query: {
                per_page: 10,
                page: 1
            },
            form_data: {},
            edit_id: null,
            form_visibility: false,
            selected_ids: [],
            all_selected: false
        };

        this.list_datatype = RESTExecutor
            .list()
            .config({
                label: 'data_types',
                params: {
                    ...this.state.filter_query
                }
            })
            .connect(props.domains.datatype);

        this.post_datatype = RESTExecutor.post().config({
            label: 'data_types'
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                this.list_datatype.execute()
            })
            .connect(props.domains.datatype);

        this.patch_datatype = RESTExecutor.patch().config({
            label: 'data_types_detail'
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                this.list_datatype.execute()
            })
            .connect(props.domains.datatype);


        this.export_data = RESTExecutor.post().config({
            label: 'export'
        }).callbacks((success) => {
            this.setState({ selected_ids: [], all_selected: false })
            // console.log("download url",success)
            window.open(success.result.url, '_blank');

        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.settings);


        this.delay_search = new NetworkDelaySearch();
    };

    handlePostPatch = (data) => {

        if (this.state.edit_id) {
            this.patch_datatype.forId(this.state.edit_id).execute(data);
        } else {
            this.post_datatype.execute(data);
        }
    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        const { filter_query, selected_ids } = this.state;
        let list_datatype_resp = this
            .list_datatype
            .response();
        let export_data_resp = this.export_data.response();

        let post_datatype_resp = this.post_datatype.response();
        let patch_datatype_resp = this.patch_datatype.response();

        let rowsData = (list_datatype_resp.result && list_datatype_resp.result.rows) || [];
        let rowsMeta = list_datatype_resp.meta || {};

        return (
            <div>
                <BasicHeader no_back title="Datatypes"
                    menu_items={setting_quick_menu}
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Datatype"
                            onClick={() => {
                                this.setState({
                                    edit_id: null,
                                    form_data: {},
                                    form_visibility: true
                                })
                            }}

                        />,
                        <TransparentButton
                            label="Export"
                            hint="Export Selected Datatype"
                            disabled={selected_ids.length == 0}
                            onClick={() => {
                                this.export_data.execute({
                                    data_types: this.state.all_selected ? true : selected_ids
                                });
                            }}

                        />
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            autoFocus
                            placeholder="Search For"
                            style={{
                            }}
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                        this.delay_search.onSearch(() => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })
                                    }
                                })
                            }}
                        />
                    </div>
                    {/* {selected_ids.length != 0 && selected_ids.length == rowsMeta.data_count &&
                                rowsMeta.data_count != rowsMeta.total_count
                                && <React.Fragment>
                                    <Row type='flex' justify='center' align='middle' style={{
                                        paddingTop: 6
                                    }}>

                                        {!this.state.all_selected ? <React.Fragment>
                                            <strong>All {selected_ids.length} Datatype on this page are selected.</strong>
                                            <Button type='link' onClick={() => {
                                                this.setState({ all_selected: true })
                                            }}>Select all {rowsMeta.total_count} Datatype</Button>
                                        </React.Fragment> : <React.Fragment>
                                                <strong>All {rowsMeta.total_count} Datatype are selected.</strong>
                                                <Button type='link' onClick={() => {
                                                    this.setState({ all_selected: false })
                                                }}>Clear Selection</Button>
                                            </React.Fragment>}
                                    </Row>

                                </React.Fragment>} */}
                </div>
                <ErrorWrapper 
                error={list_datatype_resp}
                onReload={()=>{
                    this.list_datatype.execute()
                }}
                >
                             
                <div
                    className='default-card'
                    style={{
                        padding: 0
                    }}>
                    <PopUpForm
                        title={"Datatype"}
                        forCreate={this.state.edit_id
                            ? false
                            : true}
                        initialData={this.state.form_data}
                        fields={data_type_schema}
                        open={this.state.form_visibility}
                        networkState={this.state.edit_id
                            ? patch_datatype_resp
                            : post_datatype_resp}
                        onClose={() => this.setState({ form_visibility: false })}
                        onSubmit={(data) => {
                            console.log("DATA", data);
                            this.handlePostPatch(data);
                        }} />

                    <Table // rowClassName='hand-cursor'
                        className='main-table'
                        loading={list_datatype_resp.fetching || export_data_resp.fetching}
                        size='small'
                        rowSelection={{
                            onChange: (selected_ids) => {
                                if (selected_ids.length != rowsMeta.data_count) {
                                    this.setState({ all_selected: false })
                                }
                                this.setState({ selected_ids })
                            },
                            selectedRowKeys: selected_ids
                        }}
                        scroll={{ x: true }}
                        pagination={{
                            simple: false,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            pageSize: (rowsMeta && rowsMeta.requested_count),
                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                        rowKey={(record) => record.id} columns={data_type_cols({
                            onEditPressed: (id, data) => {
                                this.setState({
                                    edit_id: id,
                                    form_data: data,
                                    form_visibility: true
                                })

                            }
                        })} dataSource={rowsData} />


                </div>
                </ErrorWrapper>     
            </div>
        );
    }

    componentDidMount() {
        overrideHeaderTitle("Datatypes");
        overrideHeaderBack(null);

        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_datatype.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })
    }

    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_datatype.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }



}

export default withDomains(DataTypeList, "datatype", "settings");

